import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from './Auth/Auth';
import { Route, Switch, Redirect } from 'react-router-dom';
import Callback from './components/callback/Callback';
import Layout from './components/layout/Layout';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import MobileNotAllowed from './components/mobileNotAllowed/MobileNotAllowed';
import { withNamespaces } from 'react-i18next';
import { theme } from './components/Theme';
import { AppProvider } from './AppProvider';

export class App extends Component {
  state = {
    isMobile: false
  };

  componentDidMount() {
    window.addEventListener('resize', this._resize.bind(this));
    this._resize();
  }

  _resize() {
    const isMobile = Boolean(window.outerWidth <= theme.breakpoints.values.m);
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }

  render() {
    const { isMobile } = this.state;

    return (
      <AppProvider>
        <div className="App">
          {isMobile && <MobileNotAllowed />}
          {!isMobile && (
            <Switch>
              {/* This will not work for CS if they go to the root of the site,
              but it's more important that this works for end users */}
              <Redirect exact from="/" to="/dashboard" />
              <Route
                exact
                path="/callback"
                render={() => <Callback auth={this.props.auth} />}
              />
              <AuthenticatedRoute
                path="/"
                component={Layout}
                isPermitted={() => {
                  return true;
                }}
                requiresAuthentication={false}
                auth={this.props.auth}
              />
            </Switch>
          )}
        </div>
      </AppProvider>
    );
  }
}

App.propTypes = {
  auth: PropTypes.instanceOf(Auth).isRequired
};

export default withNamespaces()(App);
